import { render, staticRenderFns } from "./TemplateDelete.vue?vue&type=template&id=01bd0da8&scoped=true"
import script from "./TemplateDelete.vue?vue&type=script&lang=ts"
export * from "./TemplateDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd0da8",
  null
  
)

export default component.exports